import React from 'react';
import { useIncrementalRendering } from '@/hooks';
import { cellFormatter } from '@/util/helpers/chart-formatting-helpers';
import { FLOAT, INT } from '@/util/ColumnType';
import DataTableCell from '@/util/DataTableCell';
import DataTable from '@/util/DataTable';
import { Cell } from './Cell';

export type CellsRendererProps = {
  cells: DataTableCell[];
  dataTable: DataTable;
  getChartOption: any; // TODO: infer type.
};

export const CellsRenderer: React.FC<CellsRendererProps> = ({
  cells,
  getChartOption,
  dataTable,
}) => {
  const toRender = useIncrementalRendering(cells.length, 20, 100);

  return (
    <>
      {cells.slice(0, toRender).map((c, i) => {
        const formatted = cellFormatter(dataTable, getChartOption, i, true);
        const heading = dataTable.headings()[i];
        const cellValue = formatted(c.value());

        return (
          <Cell
            key={i}
            className={`widget-cell ${
              [INT, FLOAT].includes(heading.columnType().type())
                ? 'text-align-right'
                : ''
            }`}
          >
            {cellValue}
          </Cell>
        );
      })}
    </>
  );
};
